import React from 'react';
import { FiPlus } from "react-icons/fi";

const AddButton = ({ onClick, children, className = "" }) => {
  return (
    <button
      onClick={onClick}
      className={"flex items-center justify-center gap-2 px-4 h-10 bg-secondary text-darkGray rounded-xl hover:brightness-95 w-full"}
    >
      <FiPlus className="w-5 h-5 flex-shrink-0" />
      <span className="text-sm font-semibold whitespace-nowrap lg:hidden xl:inline">
        {children}
      </span>
    </button>
  );
};

export default AddButton;